<template>
  <div
    class="phone-validate-wrapper"
    :style="{ backgroundImage: `url(${bg})` }"
  >
    <div id="phone-validate" ref="wrapper" class="phone-validate">
      <div v-if="!validPhone" class="form-item">
        <div class="input-block input-phone">
          <AreaCodeSelect @areaCodeChange="onAreaCodeChange" />
          <input
            v-model="phone"
            maxlength="15"
            placeholder="请输入手机号"
            type="text"
          />
        </div>
        <div v-if="getCode" class="error">{{ phoneError }}</div>
      </div>
      <div v-if="validPhone" class="phone-display">
        手机号 {{ validPhone | phoneHide }}
      </div>
      <div v-if="!validPhone" class="form-item">
        <div class="input-block input-code">
          <input
            v-model="code"
            maxlength="6"
            placeholder="请输入验证码"
            type="text"
          />
          <div
            v-if="!interval"
            class="get-code"
            :class="{ disabled: !isEnablePhone }"
            :style="{ color: btnColor }"
            @click="getCode"
          >
            {{ sentCode ? '重发' : '获取' }}验证码
          </div>
          <div v-else class="wait-time">
            重新发送
            <span class="time-countdown">{{ times }}</span
            >s
          </div>
        </div>
        <div v-if="codeError" class="error">{{ codeError }}</div>
      </div>
      <div class="form-item btn-confirm-wrapper">
        <div
          class="input-block btn-confirm"
          :class="{
            disabled:
              (!validPhone && (!isEnablePhone || !isEnableCode)) || !isAgree,
          }"
          :style="{ background: btnColor }"
          @click="sendConfirmReq"
        >
          {{ btnText }}
        </div>
      </div>
      <Toast ref="toast"></Toast>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import { promiseLock } from '@/lib/decorates';
import Toast from '@/components/Toast/Toast.vue';
import AreaCodeSelect from '@/components/AreaCodeSelect/AreaCodeSelect.vue';
import { getQueryFromSearch } from '@/lib/util';
const CODE_TIME = 60;
@Component({
  components: {
    Toast,
    AreaCodeSelect,
  },
  filters: {
    phoneHide(value: string) {
      if (!value) {
        return value;
      }
      const reg = /(\d{3})(\d*)(\d{4})/;
      return value.replace(
        reg,
        (fullInput: string, g1: string, g2: string, g3: string) => {
          const len = g2.length;

          return g1 + new Array(len + 1).join('*') + g3;
        }
      );
    },
  },
})
export default class PhoneValidate extends Vue {
  @Prop(String) validPhone!: string;
  @Prop(Boolean) isAgree!: boolean;
  @Prop({}) btnColor!: string;
  @Prop({ default: '马上报名' }) btnText!: string;
  @Prop({}) bg!: string;
  @Prop({ default: '' }) messageType!: string;

  phone = '';
  code = '';
  phoneErrMsg = '';
  validErrMSg = '';
  interval: any = null;
  times = CODE_TIME;
  area = '86';

  sentCode = false;
  get isEnablePhone() {
    const reg = /^\d+$/;
    return reg.test(this.phone);
  }
  get isEnableCode() {
    const codeReg = /^\d{6}$/;
    return codeReg.test(this.code);
  }
  get phoneError() {
    if (this.phone === '') {
      return '';
    }
    if (this.phoneErrMsg) {
      const msg = this.phoneErrMsg;
      this.phoneErrMsg = '';
      return msg;
    }
    if (!this.isEnablePhone) {
      return '请输入正确的手机号码！';
    }
    return '';
  }
  get codeError() {
    if (this.code === '') return '';
    if (this.validErrMSg) {
      const msg = this.validErrMSg;
      this.validErrMSg = '';
      return msg;
    }
    if (!this.isEnableCode) {
      return '请输入有效验证码';
    }
    return '';
  }

  onAreaCodeChange(code: string) {
    this.area = code;
  }

  @promiseLock
  getCode() {
    if (!this.isEnablePhone) {
      return;
    }

    this.$emit('get-code');

    return window.apis
      .postValidCode(
        {
          mobile: this.phone,
          from_type: this.messageType,
          area_code: `+${this.area}`,
        },
        { ...this.$route.query, ...getQueryFromSearch() }
      )
      .then((res: any) => {
        if (res.errcode === 0) {
          this.sentCode = true;

          this.lockGetCode();
          this.toast({
            icon: 'https://res.pandateacher.com/133EFYWB1609205712219.svg',
            value: '验证码已发送，请稍后',
          });
        } else {
          this.phoneErrMsg = res.errmsg;
        }
      })
      .catch(() => {
        this.toast({
          icon: 'https://res.pandateacher.com/HAJF8SRF1609205712249.svg',
          value: '验证码发送失败',
        });
      });
  }
  @promiseLock
  sendConfirmReq() {
    if (!this.isAgree) {
      return;
    }

    // 已有验证好的手机
    if (this.validPhone) {
      this.$emit('apply');
      return;
    }
    // 手机验证逻辑
    if (!this.isEnablePhone || !this.isEnableCode) {
      return;
    }
    return window.apis
      .postAuthCode(
        {
          code: this.code,
          mobile: this.phone,
          from_type: this.messageType,
          area_code: `+${this.area}`,
        },
        {
          ...this.$route.query,
          ...getQueryFromSearch(),
        }
      )
      .then((res: any) => {
        if (res.errcode !== 0) {
          this.validErrMSg = res.errmsg;
          this.toast({
            value: res.errmsg,
          });
        } else {
          this.handleValidSucces();
        }
      })
      .catch((e: any) => {
        console.log(e);
      });
  }
  handleValidSucces() {
    this.$emit('valid-success', this.phone);
  }
  lockGetCode() {
    this.interval = setInterval(() => {
      if (--this.times <= 0) {
        clearInterval(this.interval);
        this.interval = null;
        this.times = CODE_TIME;
      }
    }, 1000);
  }
  toast(config: any) {
    let toastVm;
    if ((toastVm = this.$refs.toast) && toastVm.toast) {
      toastVm.toast(config);
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@style/helps.scss';
$main-btn-color: #ea632f;
$main-btn-hover-color: #f4b197;
$code-input-color: #ea632f;
$border-radius: 16px;

.phone-validate-wrapper {
  width: 100vw;
  height: 586px;
  overflow: hidden;
  background-size: 750px 586px;
}
.phone-validate {
  width: 680px;
  margin: 50px auto;
  padding: 46px 40px 56px;
  background-color: #ffffff;
  background-size: 680px;
  // min-height: 486px;
  border-radius: 16px;
  box-shadow: 0 2px 50px 0 rgba(51, 38, 115, 0.4);

  .input-block {
    display: flex;
    width: 100%;
    height: 112px;
    color: #615e6e;
    font-size: 34px;
    background-color: #f6f5f9;
    border-radius: $border-radius;
    input {
      height: 112px;
      color: #615e6e;
      font-size: 34px;
      letter-spacing: 0.65px;
      background: #f6f5f9;
      border: none;
      border-radius: $border-radius;
      &::placeholder {
        color: #b4b1bd;
      }
    }
  }
  .form-item {
    .error {
      margin-top: 4px;
      color: #f23666;
      font-size: 26px;
      letter-spacing: 0.49px;
    }
  }
  .form-item + .form-item {
    margin-top: 24px;
  }
  .input-phone {
    overflow: hidden;
    .prefix {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 112px;
      height: 100%;
    }
    input {
      flex: 1;
      width: 100%;
      padding-right: 30px;
    }
  }
  .input-code {
    align-items: center;
    justify-content: space-between;
    padding-right: 32px;
    padding-left: 32px;
    .get-code {
      padding: 4px 12px;
      color: $code-input-color;
      font-size: 34px;
      letter-spacing: 0.65px;
      white-space: nowrap;
      border-radius: 8px;
      &:active {
        background-color: #ece9f6;
      }
      &.disabled {
        opacity: 0.3;
      }
    }
    .wait-time {
      color: #b4b1bd;
      font-size: 30px;
      .time-countdown {
        display: inline-block;
        width: 35px;
        text-align: right;
      }
    }
    input {
      width: 300px;
      margin-right: 32px;
    }
  }
  .phone-display {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 112px;
    margin-bottom: 24px;
    color: #615e6e;
    font-size: 34px;
    letter-spacing: 0.65px;
    background-color: #f6f5f9;
    border-radius: 16px;
  }
  .btn-confirm-wrapper {
    background: #fff;
  }
  .btn-confirm {
    align-items: center;
    justify-content: center;
    color: #fff;
    font-weight: 600;
    font-size: 43px;
    background: $main-btn-color;
    background-image: url('../assets/btn-apply-large-bg.png');
    background-size: cover;
    @include forbid-select;
    &.disabled {
      opacity: 0.3;
    }
    &:active:not(.disabled) {
      opacity: 0.7;
    }
  }
}
</style>
